import { API_JWT_TOKEN_NAME, CALL_API } from '../middleware/api'

export const TRANSACTIONS_DECLINED_DEFINITIONS_REQUEST = 'TRANSACTIONS_DECLINED_DEFINITIONS_REQUEST'
export const TRANSACTIONS_DECLINED_DEFINITIONS_SUCCESS = 'TRANSACTIONS_DECLINED_DEFINITIONS_SUCCESS'
export const TRANSACTIONS_DECLINED_DEFINITIONS_FAILURE = 'TRANSACTIONS_DECLINED_DEFINITIONS_FAILURE'

export const fetchTransactionsDeclineDefinitions = () => ({
  [CALL_API]: {
    endpoint: '/api/transaction-decline-definitions',
    types: [
      TRANSACTIONS_DECLINED_DEFINITIONS_REQUEST,
      TRANSACTIONS_DECLINED_DEFINITIONS_SUCCESS,
      TRANSACTIONS_DECLINED_DEFINITIONS_FAILURE,
    ],
    method: 'GET',
    tokenType: API_JWT_TOKEN_NAME,
  },
})
